if(!window.soeraCustomJsLoaded){window.soeraCustomJsLoaded=!0;
document.addEventListener('DOMContentLoaded', function () {
  var stickyCartWrapper = document.querySelector('.sticky-cart-wrapper');
  var footer = document.querySelector('#pagefooter .section-footer');
  if (!stickyCartWrapper || !footer) return;

  var dock = document.createElement('div');
  dock.className = 'soera-sticky-cart-dock';
  footer.before(dock);
  dock.appendChild(stickyCartWrapper);
  var cartDrawerOpen = false;
  var framePending = false;

  function updateStickyCart() {
    framePending = false;
    var barHeight = stickyCartWrapper.getBoundingClientRect().height;
    if (dock.style.height !== barHeight + 'px') dock.style.height = barHeight + 'px';
    var docked = dock.getBoundingClientRect().bottom <= window.innerHeight;
    stickyCartWrapper.classList.toggle('soera-cart-docked', docked);
    var scrollThreshold = window.innerWidth <= 768 ? 1000 : 300;
    var visible = window.scrollY > scrollThreshold && !cartDrawerOpen;
    stickyCartWrapper.classList.toggle('visible', visible);
    stickyCartWrapper.inert = !visible;
    stickyCartWrapper.setAttribute('aria-hidden', String(!visible));
  }

  function scheduleUpdate() {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(updateStickyCart);
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('on:cart-drawer:after-open', function () {
    cartDrawerOpen = true;
    updateStickyCart();
  });
  document.addEventListener('on:cart-drawer:after-close', function () {
    cartDrawerOpen = false;
    updateStickyCart();
  });
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(stickyCartWrapper);
    var content = document.querySelector('#content');
    if (content) resizeObserver.observe(content);
  }
  updateStickyCart();
});
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;
  const button = form.querySelector('.btn--sticky-cart');
  const error = form.querySelector('[data-cart-error]');
  if (!button || !error) return;
  let submitting = false;
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (submitting) return;
    submitting = true;
    error.hidden = true;
    error.textContent = '';
    const originalHtml = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>';
    const xhr = new XMLHttpRequest();
    let completed = false;
    function finish(message) {
      if (completed) return;
      completed = true;
      submitting = false;
      button.innerHTML = originalHtml;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (message) {
        error.textContent = message;
        error.hidden = false;
      }
    }
    function failure() {
      let message = form.dataset.errorText;
      try {
        const response = JSON.parse(xhr.responseText);
        if (typeof response.description === 'string') message = response.description;
      } catch (_) {}
      finish(message);
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4 || completed) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        finish();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }, 1000);
      } else {
        failure();
      }
    };
    xhr.onerror = failure;
    xhr.ontimeout = failure;
    xhr.onabort = failure;
    try {
      xhr.open('POST', form.getAttribute('action').replace(/\/$/, '') + '.js', true);
      xhr.timeout = 15000;
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(new FormData(form));
    } catch (_) {
      failure();
    }
  });
});
document.addEventListener('DOMContentLoaded',function(){function initializeCarousel(sliderClass,productClass,prevBtnClass,nextBtnClass){const slider=document.querySelector(sliderClass);if(!slider)return;const products=slider.querySelectorAll(productClass);const prevBtn=document.querySelector(prevBtnClass);const nextBtn=document.querySelector(nextBtnClass);let isDragging=!1;let startX;let scrollLeft;slider.addEventListener('mousedown',startDragging);slider.addEventListener('touchstart',startDragging,{passive:!0});slider.addEventListener('mousemove',drag);slider.addEventListener('touchmove',drag,{passive:!0});slider.addEventListener('mouseup',stopDragging);slider.addEventListener('mouseleave',stopDragging);slider.addEventListener('touchend',stopDragging);if(prevBtn)prevBtn.addEventListener('click',()=>scrollToProduct('prev'));if(nextBtn)nextBtn.addEventListener('click',()=>scrollToProduct('next'));function startDragging(e){isDragging=!0;startX=e.pageX||e.touches[0].pageX;scrollLeft=slider.scrollLeft;slider.style.scrollBehavior='auto'}
function drag(e){if(!isDragging)return;e.preventDefault();const x=e.pageX||e.touches[0].pageX;const dist=x-startX;slider.scrollLeft=scrollLeft-dist}
function stopDragging(){isDragging=!1;slider.style.scrollBehavior='smooth';snapToClosestProduct()}
function snapToClosestProduct(){const productWidth=products[0].offsetWidth;const scrollPosition=slider.scrollLeft;const targetIndex=Math.round(scrollPosition/productWidth);const targetScroll=targetIndex*productWidth;slider.scrollTo({left:targetScroll,behavior:'smooth'})}
function scrollToProduct(direction){const productWidth=products[0].offsetWidth;const currentScroll=slider.scrollLeft;const targetScroll=direction==='next'?currentScroll+productWidth:currentScroll-productWidth;slider.scrollTo({left:targetScroll,behavior:'smooth'})}}
initializeCarousel('.maison-style-slider','.maison-style-product','.maison-prev-btn','.maison-next-btn');initializeCarousel('.cart-maison-style-slider','.cart-maison-style-product','.cart-maison-prev-btn','.cart-maison-next-btn');function initializeAddToCartForms(formClass,btnClass){const forms=document.querySelectorAll(formClass);forms.forEach(form=>{form.addEventListener('submit',function(event){event.preventDefault();const formData=new FormData(form);const xhr=new XMLHttpRequest();xhr.open('POST',form.action.replace(/\/cart\/add\/?$/, '/cart/add.js'),!0);const button=form.querySelector(btnClass);const originalButtonText=button.textContent;button.textContent=button.dataset.addingText||originalButtonText;button.disabled=!0;xhr.onreadystatechange=function(){if(xhr.readyState===4){console.log('XHR request completed');if(xhr.status===200){const response=JSON.parse(xhr.responseText);console.log('Product added to cart:',response);document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh',{bubbles:!0}));setTimeout(function(){document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'))},1000)}else{console.error('Error adding product to cart:',xhr.responseText)}
setTimeout(function(){button.textContent=originalButtonText;button.disabled=!1},1000)}};xhr.onerror=function(){console.error('XHR request failed');button.textContent=originalButtonText;button.disabled=!1};xhr.setRequestHeader('X-Requested-With','XMLHttpRequest');xhr.send(formData)})})}
initializeAddToCartForms('.maison-product-form','.maison-add-to-cart-btn');initializeAddToCartForms('.cart-maison-product-form','.cart-maison-add-to-cart-btn')})
}
